const activateTimeline = () => {
  const timelineSection = document.querySelector("#business-timeline");
  if (!timelineSection) return;

  const heading = timelineSection.querySelector("h2");
  const timelineWrapper = timelineSection.querySelector(".timeline-wrapper");
  if (!timelineWrapper) return;

  if (timelineWrapper.dataset.timelineObserverAttached === "true") return;
  timelineWrapper.dataset.timelineObserverAttached = "true";

  const observer = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;

        timelineWrapper.classList.add("timeline-active");
        observer.disconnect();
        delete timelineWrapper.dataset.timelineObserverAttached;
      });
    },
    { threshold: 0.35 }
  );

  observer.observe(timelineSection);
  if (heading) observer.observe(heading);
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".timeline-box").forEach((box) => {
    const btn = box.querySelector(".tl-toggle");
    if (!btn) return;

    const detail = document.getElementById(
      btn.getAttribute("aria-controls")
    );
    if (!detail) return;

    btn.addEventListener("click", () => {
      const isOpen = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!isOpen));
      box.classList.toggle("is-open", !isOpen);
      detail.hidden = isOpen;
    });
  });
});

document.addEventListener("DOMContentLoaded", activateTimeline);
document.addEventListener("turbo:load", activateTimeline);
